export class EABError extends Error {
  public url: string;
  public context: string;

  constructor(designation: string, public code: number, context?: any) {
    super();
    this.name = `${designation}`;
    this.message = `${designation}:${code}`;

    // @ifndef PROMISCUOUS
    if (context !== undefined || context !== null) {
      this.context = JSON.stringify(context);
    }
    // @endif

    // @ifdef PROMISCUOUS
    this.url = `http://phoenix.eab.com/site/#!/error/${designation}/${code}/`;

    console.error(`EAB Error (( ${designation}:${code} )) [[ ${this.url} ]]`);

    if (context !== undefined || context !== null) {
      this.context = context;
      console.dir(context);
    }
    // @endif
  }

  static FAIL(designation: string, errorCode: number, context?: any, condition?: boolean): void {
    if (condition === false || condition === undefined) {
      throw new EABError(designation, errorCode, context);
    }
  }

  static ASSERT(designation: string, condition: boolean, explanation: string): void {
    // @ifdef PROMISCUOUS
    if (condition === false) {
      throw new EABAssertion(designation, explanation);
    }
    // @endif
  }
}

export class EABAssertion extends Error {
  constructor(designation: string, explanation: string) {
    super();
    this.name = `${designation}`;
    console.warn(`EAB Assertion (( ${designation} )) explanation`);
  }
}

window.addEventListener('error', (e: ErrorEvent) => {
  // @ifndef PROMISCUOUS
  console.debug(`${e.message} in ${e.filename} at ${e.lineno}:${e.colno} after ${e.timeStamp}`);
  // @endif
  // @ifdef PROMISCUOUS
  const logMessage: string = `${e.message} in ${e.filename} at ${e.lineno}:${e.colno} after ${e.timeStamp}`;

  if (typeof XMLHttpRequest === 'undefined') {
    return;
  }

  // DISABLED until we get an endpoint
  /*
   const request: any = new XMLHttpRequest();
   
   request.open('GET', `api/v1/log?entry=${logMessage}`);
   request.send();
  */
  // @endif
});

// ---------------------------
// Module
// ---------------------------

window['EABAssertion'] = EABAssertion;
window['EABError'] = EABError;

export default EABError;



// WEBPACK FOOTER //
// ./app/vendor/core-js-error/src/main.ts